import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getEstimateNumber(cookies, plantId, estimateDate) {
    const dateParam = encodeURIComponent(estimateDate || '');
    const url = `${apiBaseUrl}/concrete_estimators/estimate_number/?plant_id=${plantId}&estimate_date=${dateParam}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getConcreteEstimatorList(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/concrete_estimators/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getConcreteEstimatorDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/concrete_estimators/${id}/`).then((r) => r.data);
}

export function createConcreteEstimator(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/concrete_estimators/`, payload).then((r) => r.data);
}

export function updateConcreteEstimator(cookies, id, payload) {
    return getApiClient(cookies).put(`${apiBaseUrl}/concrete_estimators/${id}/`, payload).then((r) => r.data);
}

export function deleteConcreteEstimator(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/concrete_estimators/${id}/`).then((r) => r.data);
}

export function printConcreteEstimator(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/concrete_estimators/${id}/print_estimate/`, {
        responseType: 'blob',
    }).then((response) => response.data);
}

export async function getFinishedGoodsGrades(cookies) {
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/finished_goods_grades/`)
        .then((r) => r.data);
}

export async function getDesignMixOptions(cookies, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
        }
    });
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/design_mix_options/?${query.toString()}`)
        .then((r) => r.data);
}

export async function applyDesignMixToRateWorking(cookies, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
        }
    });
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/apply_design_mix/?${query.toString()}`)
        .then((r) => r.data);
}

export async function getDieselRate(cookies, plantId) {
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/diesel_rate/?plant_id=${plantId}`)
        .then((r) => r.data);
}

export async function getRateWorkingPreview(cookies, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
        }
    });
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/concrete_estimators/rate_working_preview/?${query.toString()}`)
        .then((r) => r.data);
}
